// #region IMPORT
import { Builder } from "../../api.baseQuery";
import { IEndpointTags } from "../../api.endpoint";
import {
  AdminEndpoint,
  adminEndpoint,
  adminTagTypes,
} from "./admin/admin.endpoint";
import {
  MaintainerEndpoint,
  maintainerEndpoint,
  maintainerTagTypes,
} from "./maintainer/maintainer.endpoint";
// #endregion

// #region INTERFACES
export type UserEndpoint = AdminEndpoint & MaintainerEndpoint;
// #endregion

// #region ENDPOINT
export const userTagTypes: IEndpointTags<UserEndpoint> = {
  ...adminTagTypes,
  ...maintainerTagTypes,
};

export const userEndpoint = (builder: Builder): UserEndpoint => ({
  ...adminEndpoint(builder),
  ...maintainerEndpoint(builder),
});
// #endregion
